export default function isMobile() {
  return navigator.userAgent.indexOf("Mobi") > -1;
}
